/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_Docs_DescInputs */

const en_mk_nav_docs_desc = /** @type {(inputs: Mk_Nav_Docs_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guides from your very first step.`)
};

const id_mk_nav_docs_desc = /** @type {(inputs: Mk_Nav_Docs_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panduan penggunaan dari langkah pertama.`)
};

/**
* | output |
* | --- |
* | "Guides from your very first step." |
*
* @param {Mk_Nav_Docs_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_docs_desc = /** @type {((inputs?: Mk_Nav_Docs_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_Docs_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_docs_desc(inputs)
	return en_mk_nav_docs_desc(inputs)
});